


















































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import RegexValidators from '@/shared/regex-validators';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import jsEncrypt from '@/shared/jsEncrypt';

const cssPrefix = 'confirm-email';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
  },
})
export default class ConfirmEmail extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle = '';
  confirmEmail : any = '';
  email : any = '';
  isSubmitted : boolean = false;
  showNoMatchError : boolean = false;
  emailValidator = new RegExp(RegexValidators.email);
  userNameValidator = new RegExp(RegexValidators.userName);
  numericValidator = new RegExp(RegexValidators.numeric);
  federatedEmailExtensions = ['SNWLQA.ORG', 'LATTEDEV.COM', 'SONICWALL.COM', 'SOFTWARE.DELL.COM'];
  isfederated : boolean = false;
  fetchOTPCode: boolean = false;
  // useMyCred : boolean = false;
  @Prop({ required : true })
  optedForFederated : any;
  @Prop({ required: true })
  tfaOption: any;
  domainUserName = '';
  domainPassword = '';
  flagOptedForFederated : boolean = false;
  isEmailDisabled : boolean = false;
  pwd = '';
  newEmailOtp = '';
  appOtp = '';
  showPasswordError  : boolean = false;
  showPasswordMatchError : boolean = false;
  verificationCodeSentText: string = '';
  created() {
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.isSubmitted = true;
    if (this.checkValidation()) {
      let request : any;
      if (this.isfederated) {
        request = {
          emailAddress: this.confirmEmail,
          federatedUserName: this.domainUserName,
          federatedPassword: jsEncrypt
          .getEncryptObj_msw()
          .encrypt(this.pwd),
        };
      } else {
        request = {
          emailAddress: this.confirmEmail,
          newpassword: jsEncrypt
          .getEncryptObj_msw()
          .encrypt(this.pwd),
        };
      }
      if (this.fetchOTPCode) {
        request = {
          isOverRide: 'YES',
          emailAddress: this.confirmEmail,
          password: jsEncrypt
          .getEncryptObj_msw()
          .encrypt(this.pwd),
          newEmailOtp: this.newEmailOtp,
          oldemailotp: this.appOtp,
        };
      } else {
        request = {
          emailAddress: this.confirmEmail,
          isOverRide: 'NO',
          newEmailOtp: '',
          oldemailotp: '',
          password: '',
        };
      }
      // this.$emit('confirm-email', request);
      localStorage.setItem('useMSWToken', 'true');
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/updateEmail', request)
      .then((resp) => {
        this.$store.commit('stopLoading');
        localStorage.removeItem('useMSWToken');
        console.warn(`${window.top.location.origin}/muir/login?mode=emailChanged`);
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          localStorage.removeItem('currentUser');
          if (this.$route.query && this.$route.query.mode === 'APP') {
            const str = `${window.top.location.origin}/muir/login?mode=emailChanged`;
            window.top.location.href = str;
          } else {
            this.$router.push({ path: '/login/login-view', query: { mode: 'emailChanged' } });
          }
        } else if (resp.msgCode === 'MSWAPP:TFAEMAILSENT') {
          this.fetchOTPCode = true;
          this.isEmailDisabled = true;
          this.isSubmitted = false;
          this.verificationCodeSentText = resp.msgDesc;
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      });
    }
  }
  onClickResend() {
    let request : any;
    if (this.isfederated) {
      request = {
        emailAddress: this.confirmEmail,
        federatedUserName: this.domainUserName,
        federatedPassword: jsEncrypt
        .getEncryptObj_msw()
        .encrypt(this.pwd),
      };
    } else {
      request = {
        emailAddress: this.confirmEmail,
        newpassword: jsEncrypt
        .getEncryptObj_msw()
        .encrypt(this.pwd),
      };
    }
    if (this.fetchOTPCode) {
      request = {
        isOverRide: 'YES',
        emailAddress: this.confirmEmail,
        password: jsEncrypt
        .getEncryptObj_msw()
        .encrypt(this.pwd),
        newEmailOtp: this.newEmailOtp,
        resent: 'NEW',
      };
    } else {
      request = {
        emailAddress: this.confirmEmail,
        isOverRide: 'NO',
        newEmailOtp: '',
        oldemailotp: '',
        password: '',
      };
    }
    localStorage.setItem('useMSWToken', 'true');
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/updateEmail', request)
    .then((resp) => {
      this.$store.commit('stopLoading');
      localStorage.removeItem('useMSWToken');
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        this.$router.push({ path: '/login/login-view', query: { mode: 'emailChanged' } });
      } else if (resp.msgCode === 'MSWAPP:TFAEMAILSENT') {
        this.fetchOTPCode = true;
        this.isEmailDisabled = true;
        this.isSubmitted = false;
        this.verificationCodeSentText = resp.msgDesc;
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }
  checkValidation() {
    let validateFlag = true;
    if (this.email.trim() !== this.confirmEmail.trim()) {
      this.showNoMatchError = true;
      validateFlag = false;
    }
    if (!this.email.match(this.emailValidator)) {
      validateFlag = false;
    }
    if (this.pwd.match(this.userNameValidator) && this.isfederated) {
      validateFlag = false;
    }
    if (this.fetchOTPCode && this.pwd.trim().length === 0) {
      validateFlag = false;
    }
    if (this.fetchOTPCode && !this.newEmailOtp.match(this.numericValidator)) {
      validateFlag = false;
    }
    if (this.fetchOTPCode && this.tfaOption === 'APP' && !this.appOtp.match(this.numericValidator)) {
      validateFlag = false;
    }
    // if (this.optedForFederated && this.flagOptedForFederated && this.pwd !== this.newEmailOtp) {
    //   this.showPasswordMatchError = true;
    //   validateFlag = false;
    // }
    return validateFlag;
  }
  cancel() {
    this.$emit('close-modal');
  }
  onEmailInput() {
    // this.isfederated =  false;
    // this.flagOptedForFederated = false;
    // this.useMyCred = false;
    // if (this.email.match(this.emailValidator)) {
    //   if (this.isFederatedEmail(this.email.split('@')[1])) {
    //     this.isfederated = true;
    //     this.flagOptedForFederated = false;
    //   } else {
    //     this.isfederated = false;
    //     this.flagOptedForFederated = true;
    //   }
    // }
  }
  isFederatedEmail(email : any) {
    return (this.federatedEmailExtensions.indexOf(email.toUpperCase()) !== -1);
  }
}
